const SPACER_SIZES = {
  none: '0',
  sm: '0.5rem',
  md: '1rem',
  lg: '2rem',
  xl: '4rem',
  '2xl': '8rem',
  '3xl': '12rem',
};

interface SpacerProps {
  size: keyof typeof SPACER_SIZES;
}

function Spacer({ size }: SpacerProps) {
  return <div style={{ height: SPACER_SIZES[size], width: '100%' }} />;
}

export { Spacer };
